import { h } from "preact";
import { useDispatch } from "react-redux";

import tracking from "../tracking/tracking";
import { classNames } from "../helpers";
import notificationsApi from "../api/notifications";
import { sendError } from "../errors";
import { markNotificationAsRead } from "../store";

export default function NotificationBubble({ notification, ...props }) {
  const dispatch = useDispatch();

  async function handleClick() {
    if (!notification) {
      return;
    }

    tracking.track("notification_bubble.clicked", {
      target_id: notification.targetId,
      type: notification.type,
    });
    try {
      await notificationsApi.markAsRead(
        notification.targetId,
        notification.type
      );

      dispatch(markNotificationAsRead(notification));
    } catch (err) {
      console.error(err);
      sendError("Could not mark notification as read.", {
        targetId: notification.targetId,
        type: notification.type,
      });
    }
  }

  return (
    <span
      role="button"
      onClick={handleClick}
      class={classNames(
        "notification-bubble",
        !!(notification && notification.unread) &&
          "notification-bubble--active",
        props.class
      )}
    ></span>
  );
}
